<template>
  <div>
    <b-modal
      id="password"
      ref="modal"
      title="Change Password"
      @ok="handleChangePassword"
      ok-title="Change Password"
    >
      <form ref="form" @submit.stop.prevent="changePassword">
        <b-form-group id="input-group-1" label="Verification Code:" label-for="input-1">
          <b-form-input
            id="input-1"
            v-model="$v.form.token.$model"
            :state="validateState('token')"
            aria-describedby="input-1-live-feedback"
            type="text"
            placeholder=""
          ></b-form-input>
          <b-form-invalid-feedback id="input-2-live-feedback"
            >Verification code is required.
          </b-form-invalid-feedback>
          <b-button @click="sendPasswordCode" class="ht-btn ht-btn-xs mt-2">
            Email Verification Code
          </b-button>
        </b-form-group>
        <b-form-group
          id="input-group-2"
          label="New Password:"
          label-for="input-2"
          description="Use 8 or more characters with a mix of letters numbers & symbols."
        >
          <b-form-input
            id="input-2"
            v-model="$v.form.password.$model"
            :state="validateState('password')"
            aria-describedby="input-2-live-feedback"
            type="password"
            placeholder=""
          ></b-form-input>
          <b-form-invalid-feedback id="input-2-live-feedback"
            >Password does not meet minimum requirements.
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group id="input-group-3" label="Confirm New Password:" label-for="input-3">
          <b-form-input
            id="input-3"
            v-model="$v.form.confirmPassword.$model"
            :state="validateState('confirmPassword')"
            aria-describedby="input-3-live-feedback"
            type="password"
            placeholder=""
          ></b-form-input>
          <b-form-invalid-feedback id="input-3-live-feedback"
            >Passwords do not match.
          </b-form-invalid-feedback>
        </b-form-group>
      </form>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios'
import { validationMixin } from 'vuelidate'
import { minLength, required, sameAs } from 'vuelidate/lib/validators'
import { helpers } from 'vuelidate/lib/validators'

import { handleGlobalError } from '../../util'
const passwordReq = helpers.regex(
  'passwordReq',
  /^(?=.*?[a-zA-Z])(?=.*?[0-9])(?=.*?[#?!@$ %^&*-]).{8,}$/
)

export default {
  data() {
    return {
      form: {
        password: '',
      },
      // passwordState: null,
      verified: false,
    }
  },
  mixins: [validationMixin],
  validations: {
    form: {
      token: {
        required,
      },
      password: {
        required,
        passwordReq,
        minLength: minLength(8),
      },
      confirmPassword: {
        sameAsPassword: sameAs('password'),
      },
    },
  },
  methods: {
    // checkFormValidity() {
    //   const valid = this.$refs.form.checkValidity()
    //   this.passwordState = valid
    //   return valid
    // },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
      this.$bvModal.hide('password')
      this.$bvModal.show('token')
    },
    handleChangePassword(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.changePassword()
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    async sendPasswordCode() {
      try {
        await axios.post(`${process.env.VUE_APP_PXL_API}/authmanagement`, {
          action: 'sendResetPwd',
          value: { email: this.$store.getters.user.email },
          notifierOptions: { preferredComm: 'email' },
        })
        // alert(JSON.stringify(user))
        this.successEmailToast()
      } catch (error) {
        console.error('error trying to change password', error)
        handleGlobalError(this, error, 'change password')
      }
      // // Exit when the form isn't valid
      // if (!this.checkFormValidity()) {
      //   return
      // }
    },
    async changePassword() {
      try {
        await axios.post(`${process.env.VUE_APP_PXL_API}/authmanagement`, {
          action: 'resetPwdShort',
          value: {
            user: { email: this.$store.getters.user.email },
            token: this.form.token,
            password: this.form.password,
          },
        })
        // alert(JSON.stringify(user))
        this.successPasswordToast()
        // Hide the modal manually
        this.$nextTick(() => {
          this.$bvModal.hide('password')
        })
      } catch (error) {
        console.error('error trying to change password', error)
        handleGlobalError(this, error, 'change password')
      }
    },
    successEmailToast() {
      this.$bvToast.toast('We have emailed a code to verify your new password.', {
        title: 'Verify Password',
        variant: 'success',
        solid: true,
        toaster: 'b-toaster-top-center',
      })
    },
    successPasswordToast() {
      this.$bvToast.toast('Password has been successfully changed!', {
        title: 'Password Changed',
        variant: 'success',
        solid: true,
        toaster: 'b-toaster-top-center',
      })
    },
  },
}
</script>
